import { BooleanFeatureFlag } from "@me8eon/featureflags";

export const metaHumanFFName = "metaHuman";
export const metaHumanFeatureFlag: BooleanFeatureFlag = {
    value: false,
    description: "Enable meta human",
};